<template>
	<page>
		<module :title="verify ? '优惠券审核' : '优惠券详情'">
			<div v-if="couponInfo">
				<c-detail title="基础信息">
					<c-detail-item label="优惠券名称">{{couponInfo.coupon_name}}</c-detail-item>
					
					<c-detail-item label="优惠券类型">{{dict.couponType[couponInfo.coupon_kinds] || ''}}</c-detail-item>
					
					<c-detail-item label="优惠力度">{{couponSales}}</c-detail-item>
					
					<c-detail-item label="使用说明">{{couponInfo.coupon_description}}</c-detail-item>
				</c-detail>
				
				<c-detail title="适用范围">
					<c-detail-item label="使用条件简述">{{couponInfo.commodity_remark}}</c-detail-item>
					
					<c-detail-item label="可用范围">{{dict.couponRange[couponInfo.commodity_range] || ''}}</c-detail-item>
					
					<c-detail-item v-if="couponInfo.commodity_range == 2" label="指定商品" full>
						<c-table :data="productList" height="auto" border :paging="false" style="width:1000px;">
							<c-table-column
								label="状态"
								name="state"
								width="100"
							>
								<template v-slot="{data}">
									{{dict.productState[data.state]}}
								</template>
							</c-table-column>
							
							<c-table-column
								label="商品信息"
								name="product_name"
								width="250"
							>
								<template v-slot="{data}">
									<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
									<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
								</template>
							</c-table-column>
							
							<c-table-column
								label="上架时间"
								name="sell_state_date"
								width="150"
							></c-table-column>
						</c-table>
					</c-detail-item>
					
					<c-detail-item v-else-if="couponInfo.commodity_range == 3" label="指定条件" full>
						<p v-html="couponInfo.commodity_condition_str"></p>
					</c-detail-item>
				</c-detail>
			</div>
			
			<template v-if="verify" slot="button">
				<c-button color="main" size="form" @click="verifyHandle(2)">审核通过</c-button>
				<c-button size="form" color="red" @click="verifyHandle(-1)">审核驳回</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import productInfo from '@/components/public/product_info.vue'
	
	export default {
		name: 'coupon_detail',
		
		components: {
		    productInfo
		},
		
		props: {
			id: String,
			
			verify: Boolean
		},
		
		data() {
			return {
				couponInfo: '',
				productList: []
			}
		},
		
		computed: {
			...mapState(['dict']),
			
			couponSales() {
				return `${this.couponInfo.coupon_kinds == 1 ? '无门槛' : this.couponInfo.coupon_kinds == 2 ? '满'+this.couponInfo.condition_amount+'元' : '每满'+this.couponInfo.condition_amount+'元'}减${this.couponInfo.decrease_amount}元`
			}
		},
		
		watch: {
			id() {
				this.getCoupontDetail();
			}
		},
		
		mounted() {
			this.getCoupontDetail();
		},
		
		methods: {
			getCoupontDetail() {
				this.request({
					url: '/couponInfo/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.couponInfo = data;
						
						if (data.commodity_range == 2) {
							this.productList = data.product_list || [];
						}
					}
				});
			},
			
			verifyHandle(state) {
				this.request({
					url: '/couponInfo/apply',
					data: {
						id: this.id,
						state
					},
					loading: true,
					success: () => {
						this.$message({
							type:'success',
							message: '审核成功'
						});
						this.navigateTo('/coupon');
					}
				});
			}
		}
	}
</script>